export default {
      id: "ic_nav_watch_green-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_nav_watch_green-usage",
      toString: function () {
        return this.url;
      }
    }